export function getEnumToList(
  Enum: any,
  addOrRemoveEnumList: any = null,
  isSelectFromList: boolean = false
): Array<any> {
  var options = [];
  const key = Object.keys(Enum);

  var data = key.slice(key.length / 2);
  data.forEach((x, i) => {
    if (!addOrRemoveEnumList || addOrRemoveEnumList?.length == 0) {
      options.push({ value: i, text: x });
    } else if (
      !isSelectFromList &&
      addOrRemoveEnumList.findIndex((y) => Enum[y] === x) <= -1
    ) {
      options.push({ value: i, text: x });
    } else if (
      isSelectFromList &&
      addOrRemoveEnumList.findIndex((y) => Enum[y] === x) > -1
    ) {
      options.push({ value: i, text: x });
    }
  });

  return options;
}

export function hasContentInHTMLTags(html: string): boolean {
  const regex = /<[^>]+>[^<]+<\/[^>]+>/;

  return regex.test(html);
}

export function extractAttributeFromTag(attribute: string, htmlString: string) {
  let srcIndex = htmlString.indexOf(`${attribute}="`);

  if (srcIndex !== -1) {
    let srcStartIndex = srcIndex + `${attribute}="`.length;
    let srcEndIndex = htmlString.indexOf('"', srcStartIndex);
    let srcValue = htmlString.substring(srcStartIndex, srcEndIndex);

    return srcValue;
  }
  return '';
}

export function DeepCompare(obj1: any, obj2: any, excludes?: string[]) {
  // Loop through properties in object 1
  // tslint:disable-next-line: forin
  for (const p in obj1) {
    if (excludes && excludes.includes(p)) {
      continue;
    }
    // Check property exists on both objects

    if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
      return false;
    }

    if (
      (obj1[p] !== null && obj2[p] === null) ||
      (obj1[p] === null && obj2[p] !== null)
    ) {
      return false;
    }

    switch (typeof obj1[p]) {
      // Deep compare objects
      case "object":
        if (obj1[p] !== null) {
          if (!DeepCompare(obj1[p], obj2[p])) {
            return false;
          }
        }
        break;
      // Compare function code
      case "function":
        if (
          typeof obj2[p] === "undefined" ||
          obj1[p].toString() !== obj2[p].toString()
        ) {
          return false;
        }
        break;
      // Compare values
      default:
        if (obj1[p] !== obj2[p] || !obj1[p] !== !obj2[p]) {
          return false;
        }
    }
  }

  // Check object 2 for any extra properties
  for (const p in obj2) {
    if (typeof obj1[p] === "undefined") {
      return false;
    }
  }

  // Compare dates
  if (obj1 instanceof Date || obj2 instanceof Date) {
    return obj1?.getTime() === obj2?.getTime();
  }

  return true;
}

export class Function {

  static sortItems(items: any[]): any[] {
    return items.slice().sort((item1, item2) => {
      if (item1.title.toLowerCase() < item2.title.toLowerCase()) {
        return -1;
      }
      if (item1.title.toLowerCase() > item2.title.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }
}

export class businessHours {
  static groupBySameTiming(hours: any[]): string[] {
    if (hours.length === 0) {
      return [];
    }
    hours.sort((a, b) => a.day - b.day);
    const firstDay = hours[0];
    let sameTiming = true;
    for (let i = 1; i < hours.length; i++) {
      const currentDay = hours[i];
      if (currentDay.from !== firstDay.from || currentDay.to !== firstDay.to || currentDay.day !== firstDay.day + i) {
        sameTiming = false;
        break;
      }
    }

    if (sameTiming) {
      const dayRange = this.getDayRanges(hours.map(hour => hour.day));
      return [`${dayRange} ${firstDay.from} - ${firstDay.to}`];
    } else {
      return hours.map((hour) => `${this.getDayName(hour.day)} ${hour.from} - ${hour.to}`);
    }
  }

  static getDayRanges(days: number[]): string[] {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const sortedDays = days.sort((a, b) => a - b);
    const ranges = [];
    let start = sortedDays[0];
    let end = start;
    for (let i = 1; i < sortedDays.length; i++) {
      if (sortedDays[i] === end + 1) {
        end = sortedDays[i];
      } else {
        ranges.push(this.formatDayRange(start, end, dayNames));
        start = sortedDays[i];
        end = start;
      }
    }
    ranges.push(this.formatDayRange(start, end, dayNames));
    return ranges;
  }

  static formatDayRange(start: number, end: number, dayNames: string[]): string {
    if (start === end) {
      return dayNames[start];
    } else {
      return `${dayNames[start]}-${dayNames[end]}`;
    }
  }

  static getDayName(day: number): string {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return dayNames[day];
  }
}

export class businessStatus {
  /**
   * "h:mm AM/PM" (the business-hour picker format; also "hh:mm AM", "HH:mm",
   * "HH:mm:ss") → minutes since midnight, or null when unreadable.
   *
   * The previous parser added 12 to any "PM" hour, so "12:30 PM" became 24:30 —
   * every restaurant read "closed now" for the whole lunch hour — and "12:xx AM"
   * (midnight) read as noon.
   */
  static toMinutes(time: string | null | undefined): number | null {
    if (time === null || time === undefined) {
      return null;
    }
    const match = String(time).trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*([AaPp][Mm])?$/);
    if (!match) {
      return null;
    }
    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const period = match[3]?.toUpperCase();
    if (period) {
      if (hours < 1 || hours > 12) {
        return null;
      }
      hours = hours % 12; // 12 AM → 0, 12 PM → 0 + 12 below
      if (period === 'PM') {
        hours += 12;
      }
    } else if (hours > 23) {
      return null;
    }
    if (minutes > 59) {
      return null;
    }
    return hours * 60 + minutes;
  }

  /** Accepts the numeric day the API returns (0 = Sunday) or a day name. */
  static toDayIndex(day: any): number {
    if (typeof day === 'number') {
      return day;
    }
    const numeric = Number(day);
    if (!Number.isNaN(numeric) && String(day).trim() !== '') {
      return numeric;
    }
    return ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(String(day).trim().slice(0, 3).toLowerCase());
  }

  /**
   * True when any slot covers `now` (device local time). Slots carry `day`,
   * `from`/`to` (or `From`/`To`) and optionally `isOpen`. A slot whose end is not
   * after its start wraps past midnight, e.g. 6:00 PM – 2:00 AM.
   */
  static isBusinessOpen(hours: any[], now: Date = new Date()): boolean {
    if (!Array.isArray(hours) || hours.length === 0) {
      return false;
    }
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const today = now.getDay();
    const yesterday = (today + 6) % 7;

    return hours.some((slot) => {
      if (!slot || slot.isOpen === false) {
        return false;
      }
      const start = this.toMinutes(slot.from ?? slot.From);
      const end = this.toMinutes(slot.to ?? slot.To);
      if (start === null || end === null) {
        return false;
      }
      const day = this.toDayIndex(slot.day ?? slot.Day);
      if (end > start) {
        return day === today && nowMinutes >= start && nowMinutes <= end;
      }
      return (day === today && nowMinutes >= start) || (day === yesterday && nowMinutes <= end);
    });
  }

  static isTimeBetween(currentTime: string, startTime: string, endTime: string): boolean {
    const current = this.toMinutes(currentTime);
    const start = this.toMinutes(startTime);
    const end = this.toMinutes(endTime);
    if (current === null || start === null || end === null) {
      return false;
    }
    if (end > start) {
      return current >= start && current <= end;
    }
    return current >= start || current <= end;
  }
}

/**
 * `triggers` value for an ngbTooltip that carries real content (opening hours,
 * long lists): hover/focus where there is a mouse, click where there is not.
 * Hover-only tooltips can never be opened from a touch screen, and combining
 * hover with click makes a tap open-then-close in the same gesture.
 */
export function tooltipTriggers(): string {
  const canHover =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  return canHover ? 'hover focus' : 'click';
}

export function getCustomMarkerIcon(url: string): google.maps.Icon {
  return {
    url: url,
    scaledSize: new google.maps.Size(30, 30),
    origin: new google.maps.Point(0, 0),
  };
}

export function urlValidation(value: string) {
  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  return urlPattern.test(value);
};

export function getRandomItems<T>(list: T[], numItems: number): T[] {
  const randomItems: T[] = [];
  const listLength = list.length;
  numItems = Math.min(numItems, listLength);
  while (randomItems.length < numItems) {
    const randomIndex = Math.floor(Math.random() * listLength);
    const randomItem = list[randomIndex];
    if (!randomItems.includes(randomItem)) {
      randomItems.push(randomItem);
    }
  }
  return randomItems;
}
